import { render, staticRenderFns } from "./CollectMaterialDetail.vue?vue&type=template&id=056c50ba&scoped=true&"
import script from "./CollectMaterialDetail.vue?vue&type=script&lang=js&"
export * from "./CollectMaterialDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollectMaterialDetail.vue?vue&type=style&index=0&id=056c50ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056c50ba",
  null
  
)

export default component.exports